import { PrismicLinkContext } from '@monofront/types';
import { PrismicLink } from '../PrismicLink';

const CustomPrismicLink =
  (context: PrismicLinkContext, className?: string) =>
  (_type, element, content, _children, index) => {
    return (
      <PrismicLink
        key={index}
        link={element.data}
        className={className}
        context={context}
      >
        {content}
      </PrismicLink>
    );
  };

export default CustomPrismicLink;
